import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  Chip,
  Stack,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import TuneIcon from "@mui/icons-material/Tune";
import { NumericFormat } from "react-number-format";
import SnackbarContext from "../GeneralContext/SnackbarContext";
import InputFile from "../GeneralComponents/InputFile";
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";

export default function ParqueInicio() {
  const { pageTitle, setPageTitle, setDrawerHidding } =
    useContext(GeneralContext);
  const [loading, setLoading] = useState(false);
  const [RBDList, setRBDList] = useState([]);
  const [rbdLoading, setRbdLoading] = useState(false);
  const [fechaInicio, setFechaInicio] = useState(dayjs());

  const [autoCompleteInput, setAutoCompleteInput] = useState("");

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const openSnackbar = useContext(SnackbarContext);

  const [formData, setFormData] = useState({
    rbd_list: [],
    oficio_inicio_servicio: "",
    fecha_inicio_servicio: dayjs(),
  });

    const links = [
    { name: "Estado de Parque", path: "/parque_lista" },
    { name: "Inicio de Servicio", path: "/parque_inicio" },
  ];


  const [evErrorInicio, setEvErrorInicio] = useState(false);

  const [inicioFile, setInicioFile] = useState();
  const setFileInicio = (archivo) => {
    setEvErrorInicio(!archivo ? true : false);
    setInicioFile((prevData) => ({
      ...prevData,
      archivo,
    }));
  };

  function getRBD() {
    if (autoCompleteInput !== "") {
      setRbdLoading(true);
      axios
        .getRBD(autoCompleteInput)
        .then((response) => {
          setRBDList(response.data.rbd_list);
          setRbdLoading(false);
          setError(false);
          setErrorMsg("");
        })
        .catch(() => {
          setRBDList([]);
          setRbdLoading(false);
          setError(true);
          setErrorMsg("Colegio no encontrado.");
        });
    }
  }

  useEffect(() => {
    if (autoCompleteInput) {
      getRBD();
    }
  }, [autoCompleteInput]);

  const handleAddRow = () => {
    if (!autoCompleteInput) {
      setError(true);
      setErrorMsg("Selecciona un RBD antes de agregar.");
      return;
    }

    if (formData.rbd_list.includes(autoCompleteInput)) {
      //setError(true);
      //setErrorMsg("El RBD ya está en la lista.");
      return;
    }

    setFormData({
      ...formData,
      rbd_list: [...formData.rbd_list, autoCompleteInput],
    });
    setAutoCompleteInput("");
    setError(false);
    setErrorMsg("");
  };

  function toStructure(arr, fecha) {
  return  arr.map(v => {
      if (v && typeof v === "object") {
        const rbd = String(v.rbd ?? v.RBD ?? v.id ?? v);
        const f = v.fecha_oficio ?? fecha;
        return { rbd, fecha_oficio: f };
      }
      return { rbd: String(v), fecha_oficio: fecha };
    })
  ;
}

  const handleSend = (event) => {
    event.preventDefault();

    if (formData.rbd_list.length === 0) {
      return;
    }

    const updatedFormData = {
      url_oficio: "",
      descripcion:"",
      numero_oficio: formData.oficio_inicio_servicio,
      fecha_oficio: formData.fecha_inicio_servicio.toISOString().replace("Z",""),
      tipo_oficio: "INICIO_SERVICIO",
      rbds: toStructure(formData.rbd_list, formData.fecha_inicio_servicio.toISOString().replace("Z",""))
    };


    setLoading(true);
    if (!inicioFile ) {
      setEvErrorInicio(inicioFile ? true : false);
      setLoading(false);
      return;
    }


    const form = new FormData();

    form.append("prefactura_oficios", JSON.stringify(updatedFormData));


    form.append("file", inicioFile.archivo, "temp.pdf");
    axios
      .putOficiosRBD(form)
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        openSnackbar(
          "Uno mas de los RBD ingresados no estan vinculados a un oficio",
          "error"
        );
      });
  };

  const handleDeleteChip = (chipToDelete) => {
    setFormData({
      ...formData,
      rbd_list: formData.rbd_list.filter((chip) => chip !== chipToDelete),
    });
  };

  useEffect(() => {
    setPageTitle("Listado de reportes");
  }, [pageTitle, setPageTitle]);

  useEffect(() => {
    setDrawerHidding(false);
  }, []);

  return (
    <PageBody>
    <BreadcrumbStandard links={links} />
      <PageBgBlock>
        <form onSubmit={handleSend} id="parque_date">
          <Stack alignItems="left" justifyContent="center" spacing={2}>
            <Typography
              variant="h1"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
            >
              INICIO SERVICIO
            </Typography>
            <Box
              justifyContent="center"
              sx={{
                maxWidth: "100%",
                margin: "0 auto",
                display: "flex",
              }}
            >
              <Typography
                variant="body"
                align="center"
                sx={{ marginBottom: "3rem", maxWidth: "45rem" }}
              >
                Para <b>agregar</b> fecha y oficio relacionado con inicio de
                servicio llene los campos, cuide que la información esté
                correcta antes de agregar.
              </Typography>
            </Box>
          </Stack>

          <Grid container spacing={2}>
            <Grid size={4} sx={{mb: 1}}>
              <FormControl sx={{ minWidth: "100%" }}>
                <Autocomplete
                  value={autoCompleteInput}
                  onChange={(event, newValue) =>
                    setAutoCompleteInput(newValue || "")
                  }
                  inputValue={autoCompleteInput}
                  onInputChange={(event, newValue) =>
                    setAutoCompleteInput(newValue || "")
                  }
                  disablePortal
                  loading={rbdLoading}
                  loadingText="Cargando..."
                  options={RBDList}
                  autoComplete
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      error={error}
                      helperText={errorMsg}
                      {...params}
                      label="RBD"
                      placeholder="Buscar RBD"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            {params.InputProps.startAdornment}
                            <TuneIcon />
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid size={3}>
              <PageButtonSimple
                pad=".5rem"
                width="auto"
                onClick={handleAddRow}
                startIcon={<AddCircleOutlineOutlinedIcon />}
                disabled={!autoCompleteInput || rbdLoading}
              >
                Agregar a la lista
              </PageButtonSimple>
            </Grid>
          </Grid>


          <Grid xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              label="Lista de RBDs"
              sx={{ marginY: 1 }}
              InputProps={{
                startAdornment: (
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 0.5,
                    }}
                  >
                    {formData.rbd_list.map((chip) => (
                      <Chip
                        key={chip}
                        label={chip}
                        onDelete={() => handleDeleteChip(chip)}
                        deleteIcon={<RemoveCircleOutlineOutlinedIcon />}
                        sx={{
                          backgroundColor: "rgba(61, 108, 174, 0.20)",
                          "& .MuiChip-deleteIcon": {
                            color: "rgba(61, 108, 174, 0.80)",
                          },
                          "&:hover .MuiChip-deleteIcon": {
                            color: "rgba(61, 108, 174, 1)",
                          },
                        }}
                      />
                    ))}
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid container spacing={2} sx={{ marginY: 1 }}>
            <Grid size={6}>
              <FormControl sx={{ width: "100%" }} size="small">
                <NumericFormat
                  required
                  customInput={TextField}
                  label="N° de oficio inicio de servicio"
                  value={formData.oficio_inicio_servicio}
                  onValueChange={(newValue) =>
                    setFormData((prevValues) => ({
                      ...prevValues,
                      oficio_inicio_servicio: newValue.value,
                    }))
                  }
                  allowNegative={false}
                  size="small"
                  sx={{ width: "100%" }}
                />
              </FormControl>
            </Grid>

            <Grid size={6}>
              <FormControl fullWidth variant="outlined" >
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={"es"}
                  localeText={
                    esES.components.MuiLocalizationProvider.defaultProps
                      .localeText
                  }
                >
                  <DateTimePicker
                    label="Oficio de inicio de servicio (facturación)"
                    slotProps={{ textField: { size: "small" } }}
                    value={formData.fecha_inicio_servicio}
                    size="small"
                    sx={{ width: "100%" }}
                    onChange={(newValue) =>
                      setFormData({
                        ...formData,
                        fecha_inicio_servicio: newValue,
                      })
                    }
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
          
            <Grid size={12}>
              <Box>
                <InputFile
                  onFileSelect={setFileInicio}
                  fileType="pdf"
                  placeholder="Oficio inicio de servicio"
                  buttonText="Subir archivo"
                  sizeBtnGrid={4}
                />
                <Typography
                  variant="small"
                  align="left"
                  sx={{
                    marginBottom: "18px",
                    color: evErrorInicio ? "red" : "#111",
                  }}
                >
                  {evErrorInicio ? "Debe adjuntar evidencia" : ""}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ margin: "auto", marginTop: "2rem" }}>
            <PageButtonSimple
              form={"parque_date"}
              startIcon={<AddCircleOutlineOutlinedIcon />}
              loading={loading}
              disabled={formData.rbd_list.length === 0}
              style="success"
              bgColor={formData.rbd_list.length === 0 ? "" : "#C8E6C9"}
            >
              Actualizar fechas
            </PageButtonSimple>
          </Box>
        </form>
      </PageBgBlock>
    </PageBody>
  );
}
